const config = {
  apiUrl: process.env.REACT_APP_API || "http://localhost:8080",
};

export default config;
